// extracted by mini-css-extract-plugin
export var bubble = "_39-0";
export var container = "_39-3";
export var contrastBorder = "_39-4";
export var greyOut = "_39-2";
export var initialsWrapper = "_39-1";
export var large = "_39-9";
export var medium = "_39-8";
export var mediumSmall = "_39-7";
export var mediumSmallMedium = "_39-c";
export var micro = "_39-5";
export var small = "_39-6";
export var tiny = "_39-b";
export var xTiny = "_39-a";